import { benefitsHeroBanner } from "@/assets/images";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { Button } from "@/pages/quiz/15000/components/Button";

const ApprovedByDoctorQuestion = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => {
  return (
    <>
      <p className="text-4xl mb-6 text-new-design-gray-500 font-medium whitespace-normal break-keep hyphens-none">
        Approved in minutes, shipped overnight.
      </p>

      <img src={benefitsHeroBanner} alt="SkinnyRx benefits" />

      <Button onClick={() => setQuestionAnswer(true)} />
    </>
  );
};

export { ApprovedByDoctorQuestion };
